import './plugins';

jQuery(document).ready(function($) {

	$('.logo-slider').slick({
		slidesToShow: 4,
		responsive: [{
			breakpoint: 767,
			settings: {
				slidesToShow: 2
			}
		}]
	});

	$('.case-study-slider').slick({
		centerMode: true,
		// centerPadding: '14.25vw',
		centerPadding: '11vw',
		slidesToShow: 2,
		slidesToScroll: 2,
		responsive: [{
			breakpoint: 767,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1,
				centerMode: false,
				centerPadding: 0
			}
		}]
	});

	// generic
	$('.transition-in').waypoint(function(direction){
		$(this.element).addClass('in-view');
	}, {
		offset: '90%'
	});

	// smooth scroll
	$('a[href*="#"]').not('[href="#"]').not('[href="#0"]').click(function(event) {
		if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
			var target = $(this.hash);
			target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
			if (target.length) {
				event.preventDefault();
				$('html, body').animate({
					scrollTop: target.offset().top
				}, 1000, function() {
					// var $target = $(target);
					// $target.focus();
					// if ($target.is(":focus")) {
					// 	return false;
					// } else {
					// 	$target.attr('tabindex','-1');
					// 	$target.focus();
					// };
				});
			}
		}
	});

});